<script>

    
    import Legend from './components/Legend.svelte';
    import Horizontal from './components/Horizontal.svelte';
    import Vertical from './components/Vertical.svelte';
    import { onMount } from 'svelte';
    import { descending } from 'd3';
    
    const DATA_URL = 'https://ix.cnn.io/data/el-nino-index/oni-rolling.json';
    
    // `data` is wired through from App.svelte (loaded from src/data/data.json)
    let { width = 600 } = $props();

    let data = $state(null);
    let topThree = $state(null);
    let narrow = $derived(width < 500);

    const highlights = [
        {
            'dt': '1983-01-01',
            'label': '1982–\'83'
        },
        {
            'dt': '1997-12-01',
            'label': '1997–\'98'
        },
        {
            'dt': '2015-11-01',
            'label': '2015–\'16'
        }
    ]

    onMount(async() => {
        try {
            const response = await fetch(DATA_URL);

            if (!response.ok) {
                throw new Error(`HTTP error, status: ${response.status}`)
            }
            data = await response.json();
            console.log(data);

            topThree = data.filter(d => d.year < 2026).sort((a, b) => {
                return descending(a.oni, b.oni);
            });
            

        } catch (error) {
            console.error('Fetch error:', error);
        }
    });

    
    
</script>

<Legend />
{#if data}
    {#if narrow}
    <Vertical {data} {width} {highlights}/>
    {:else}
    <Horizontal {data} {width} {highlights}/>
    {/if}
{/if}



<style lang='scss'>
    :global(circle), :global(rect), :global(polygon) {
        shape-rendering: crispEdges;
    }
    input {
        width: 100%;
    }
    .command {
        margin: 0;
        text-align: center;
        font-weight: 800;
        font-size: 1.2rem;
        text-transform: uppercase;
    }
    .status {
        font-size: 1rem;
        text-align: center;
        margin: 0;
        margin-bottom: 1rem;
        font-weight: 400;
    }

    :global {
        h2 strong {
            font-weight: 500!important;
        }
    }
</style>
